import type { ReviewedLibraryIdentity } from './library-identity-types';

export const LIBRARY_WARMUP_04: ReviewedLibraryIdentity[] = [
  {
    "id": "library-fanjue-spider-warmup",
    "name": "蜘蛛式热身",
    "group": "warmup",
    "subCategory": "hip-leg",
    "equipment": "bodyweight",
    "pattern": "蜘蛛式髋活动",
    "legacyIds": [
      "fanjue-spider-warmup"
    ],
    "sourceId": "course-20261008-fanjue-plan-04-01",
    "targetMuscles": [
      "髋部肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-fanjue-head-ground-press",
    "name": "头枕地颈部激活",
    "group": "warmup",
    "subCategory": "neck",
    "equipment": "bodyweight",
    "pattern": "颈部抗阻支撑",
    "legacyIds": [
      "fanjue-head-ground-press"
    ],
    "sourceId": "course-20261008-fanjue-plan-07-01",
    "targetMuscles": [
      "颈部稳定肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-fanjue-stretch-counter",
    "name": "肩部拉伸对抗激活",
    "group": "warmup",
    "subCategory": "shoulder",
    "equipment": "bodyweight",
    "pattern": "肩部拉伸对抗",
    "legacyIds": [
      "fanjue-stretch-counter"
    ],
    "sourceId": "course-20261008-fanjue-plan-07-02",
    "targetMuscles": [
      "肩部稳定肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-fanjue-foam-roller-support",
    "name": "头枕泡沫轴支撑激活",
    "group": "warmup",
    "subCategory": "neck",
    "equipment": "foam-roller",
    "pattern": "颈部支撑稳定",
    "legacyIds": [
      "fanjue-foam-roller-support"
    ],
    "sourceId": "course-20261008-fanjue-plan-07-03",
    "targetMuscles": [
      "颈部稳定肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-fanjue-internal-rotation-activation",
    "name": "肩内旋肌激活",
    "group": "warmup",
    "subCategory": "shoulder",
    "equipment": "bodyweight",
    "pattern": "肩内旋活动",
    "legacyIds": [
      "fanjue-internal-rotation-activation"
    ],
    "sourceId": "course-20261008-fanjue-plan-08-01",
    "targetMuscles": [
      "肩内旋肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-fanjue-kneeling-pushup",
    "name": "跪姿俯卧撑激活",
    "group": "warmup",
    "subCategory": "chest",
    "equipment": "bodyweight",
    "pattern": "跪姿闭链推激活",
    "legacyIds": [
      "fanjue-kneeling-pushup"
    ],
    "sourceId": "course-20261008-fanjue-plan-09-01",
    "targetMuscles": [
      "胸大肌",
      "前锯肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-fanjue-rotator-cuff-activation",
    "name": "哑铃肩袖激活",
    "group": "warmup",
    "subCategory": "shoulder",
    "equipment": "dumbbell",
    "pattern": "俯卧小负荷肩袖活动",
    "legacyIds": [
      "fanjue-rotator-cuff-activation"
    ],
    "sourceId": "course-20261008-fanjue-plan-10-01",
    "targetMuscles": [
      "肩袖肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-fanjue-chest-warmup",
    "name": "胸部综合热身",
    "group": "warmup",
    "subCategory": "chest",
    "equipment": "bodyweight",
    "pattern": "胸部肩胛综合活动",
    "legacyIds": [
      "fanjue-chest-warmup"
    ],
    "sourceId": "course-20261008-fanjue-plan-11-01",
    "targetMuscles": [
      "胸大肌",
      "前锯肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-fanjue-gluteus-minimus-activation",
    "name": "臀中肌与臀小肌激活",
    "group": "warmup",
    "subCategory": "hip-leg",
    "equipment": "bodyweight",
    "pattern": "髋外展激活",
    "legacyIds": [
      "fanjue-gluteus-minimus-activation"
    ],
    "sourceId": "course-20261008-fanjue-plan-15-01",
    "targetMuscles": [
      "臀中肌",
      "臀小肌"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  },
  {
    "id": "library-fanjue-leg-warmup",
    "name": "腿部综合热身",
    "group": "warmup",
    "subCategory": "hip-leg",
    "equipment": "bodyweight",
    "pattern": "髋腿综合活动",
    "legacyIds": [
      "fanjue-leg-warmup"
    ],
    "sourceId": "course-20261008-fanjue-plan-16-01",
    "targetMuscles": [
      "髋腿部肌群"
    ],
    "evidence": "名称、目标肌群、器械及动作姿态核对；不同教师的合集位置不合并"
  }
];
